import React, { Component } from 'react'
import { Icon } from 'antd'
import { getRegistered } from '../../contract/Oracles';

export default class OracleRegNotice extends Component {

    constructor(props) {
        super(props);

        this.state = {
            finalRender: <Icon style={{ fontSize: '16px', color: '#08c' }} theme="outlined" type="loading" />
        };

    }

    componentDidMount() {
        let self = this;
        getRegistered(self.props.bytes32Id).then((registered) => {
            if (registered) {
                self.setState({finalRender : <span style={{ fontSize: '16px', color: 'rgb(58, 197, 90)' }}><Icon type="safety" style={{ fontSize: '16px', color: 'rgb(58, 197, 90)' }} theme="outlined" /> REGISTERED</span>});
            } else {
                self.setState({finalRender : <span style={{ fontSize: '16px', color: '#e0e018' }}><Icon type="warning" style={{ fontSize: '16px', color: '#e0e018' }} theme="outlined" /> NOT REGISTERED</span>});
            }
        });

    }


    render() {
        return (this.state.finalRender)
    }
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/OracleRegNotice.js